import { mapActions } from "vuex";

export const clientRoleMixin = {
  data() {
    return {
      /**
       * Selected client role
       */
      role: {},

      /**
       * Permissions that were on the client role selected separated by roles
       */
      previousRolesAndPermissions: []
    };
  },

  methods: {
    ...mapActions([
      "fetchClientRolesByUuid",
      "deleteClientRoleByUuid",
      "fetchAllPermissions"
    ]),

    /**
     * Get client role by the uuid that is defined in the current page route
     * @return {Promise<void>}
     */
    async fetchRoleDataByUuid() {
      let uuid = this.$route.params.uuid;
      try {
        let includes = "permissions,users,companies";
        this.role = await this.fetchClientRolesByUuid({
          uuid: uuid,
          includes: includes
        });
        this.role.usersMobileAssociates = this.getUsersAssociates("mobile");
        this.role.usersWebAssociates = this.getUsersAssociates("web");
        this.previousRolesAndPermissions = await this.getPreviousRolesAndPermissions(
          this.role.permissions
        );
      } catch (error) {
        console.error(error);
        await this.$router.replace("/error");
      } finally {
        this.loading = false;
      }
    },

    /**
     * Separate the permissions associated with the selected client role by roles
     *
     * @param {Array} clientRolePermissions - Permissions for the selected client role
     * @return {Promise<[{permissions: [], name: string}, {permissions: [], name: string}, {permissions: [], name: string}, {permissions: [], name: string}]>}
     */
    async getPreviousRolesAndPermissions(clientRolePermissions) {
      let roles = [
        { name: "management", permissions: [] },
        { name: "fibercloud_web", permissions: [] },
        { name: "fibercloud_mobile", permissions: [] },
        { name: "modules", permissions: [] },
        { name: "network", permissions: [] }
      ];

      let allPermissions = await this.fetchAllPermissions("roles");

      // Separate client role permissions by roles
      // Permissions with id 195 and 196 are repeated in roles management, fibercloud_web and fibercloud_mobile
      clientRolePermissions.forEach(clientRolePermission => {
        if (
          clientRolePermission.id !== 195 &&
          clientRolePermission.id !== 196
        ) {
          let permission = allPermissions.find(
            permission => permission.id === clientRolePermission.id
          );
          if (permission) {
            let role = roles.find(
              role => role.name === permission.roles[0].name
            );
            let index = roles.indexOf(role);
            roles[index].permissions.push(clientRolePermission);
          }
        } else {
          roles[0].permissions.push(clientRolePermission);
          roles[1].permissions.push(clientRolePermission);
          roles[2].permissions.push(clientRolePermission);
        }
      });

      return roles;
    },

    /**
     * Filters the users of the selected role by the type received
     * @param type - Type of user to be filtered (web|mobile)
     * @return {[]}
     */
    getUsersAssociates(type) {
      let users = [];
      this.role.users.forEach(user => {
        if (user.type === type) {
          users.push(user);
        }
      });
      return users;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/clientRoleMixin.js